import { ReduxState } from "../store";

export const selectMultipleChoiceExamStep = (state: ReduxState) => state.exam.multipleChoiceExamStep;
export const selectKYC_ID_Photo = (state: ReduxState) => state.exam.KYC_ID_Photo;
export const selectKYC_Personal_Photo = (state: ReduxState) => state.exam.KYC_Personal_Photo;
export const selectKYC_Status = (state: ReduxState) => state.exam.KYC_Status;
export const selectExamRulesModal = (state: ReduxState) => state.exam.examRulesModal;
export const selectExitExamModal = (state: ReduxState) => state.exam.exitExamModal;
